/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { GetMarketingType } from "../../../models/_tickets";
import store from "store2";
import { useSiteVisitation } from "../../../providers/SiteVisitationProvider";

const MarketingMaterials = (props: {
  jobId:any;
}) => {
  const {jobId} = props;

  const { materialDB} = useSiteVisitation()
  const [selectedMarketingMaterials, setSelectedMarketingMaterials] = useState<
    string[]
  >([]);
  useEffect(() => {
    const jobData = store.get("job_id_data") || {};
    const jobSpecificData = jobData[jobId] || {};

    const savedMarketingMaterials = jobSpecificData.location?.selectedMarketingMaterials;

    if (savedMarketingMaterials) {
      setSelectedMarketingMaterials(savedMarketingMaterials);
    }
  }, []);
  
  const handleCheckboxChange = (marketingName: string) => {
    setSelectedMarketingMaterials((prev) => {
      const updatedSelection = prev.includes(marketingName)
        ? prev.filter((name) => name !== marketingName) // Remove if already selected
        : [...prev, marketingName]; // Add if not selected
        const jobData = store.get("job_id_data") || {};
        jobData[jobId] = {
          ...jobData[jobId],
          location: {
            ...jobData[jobId]?.location,
            selectedMarketingMaterials: updatedSelection,
          },
        };
        store.set("job_id_data", jobData);
      return updatedSelection;
    });
  };
  
  return (
    <>
      <div className="accordion mt-4" id="marketingMaterialsAccordion">
        <div className="accordion-item">
          <h2 className="accordion-header" id="marketingMaterialsHeading">
            <button
              className="accordion-button collapsed py-5 fs-4 fw-bold bg-light"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#marketingMaterialsCollapse"
            >
              Marketing Materials
            </button>
          </h2>
          <div
            id="marketingMaterialsCollapse"
            className="accordion-collapse collapse"
          >
            <div className="accordion-body">
              <div className="row">
                {materialDB.map((material: GetMarketingType, index: number) => (
                  <div key={index} className="col-lg-6 col-md-6 col-12 mb-2">
                    <div className="form-check form-check-custom form-check-solid d-flex align-items-center">
                      <input
                        className="form-check-input mb-2 me-1"
                        type="checkbox"
                        id={`material_${index}`}
                        checked={selectedMarketingMaterials.includes(material.id)}
                        onChange={() => handleCheckboxChange(material.id)}
                      />
                      <label
                        className="form-check-label fs-5"
                        htmlFor={`material_${index}`}
                      >
                        {material.name}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketingMaterials;
